import { isQueryStatementActive } from "pages/DevelopWorkspace/contexts/DocumentsContext/helpers/getQueryStatementState";
import { WorkspaceDocument } from "pages/DevelopWorkspace/workspace.types";

const isDocumentRunning = (document: WorkspaceDocument) => {
  const execution = document.execution;

  if (!execution) {
    return false;
  }

  const queryStatements = execution.queryStatements;

  if (!queryStatements || queryStatements.length === 0) {
    return false;
  }

  return queryStatements.some(isQueryStatementActive);
};

export { isDocumentRunning };
